import { errorReport404 } from '@utiles/errorReport';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';

/**
 * 创建跳转到错误页面（404页面）的方法
 * 返回的函数会在调用时使用 this.getMainHost() 获取主域名
 * @returns {Function} jumpErrorPage 方法
 */
export const createJumpErrorPage = () => {
  return function jumpErrorPage() {
    let hostName = this.getMainHost();
    let href = '';

    if (
      hostName === atob('M3N5dWEuY29t') ||
      hostName === atob('YmxhbmNvem9uZS5jb20=')
    ) {
      // 其实404路径不存在，后端根据ip跳转真实404
      href = `//www.${hostName}/404`;
    } else if (hostName === atob('c2xmdW50YXAuY29t')) {
      href = `//www.${hostName}/slfuntap/page404`;
    } else if (hostName === atob('Z25qb3kuaGs=')) {
      href = `//gwww.${hostName}/page404`;
    } else {
      href = `//www.${hostName}/page404`;
    }

    errorReport404();
    window.location.href = getGlobalGetGotoLink({ link: href });
  };
};
